import { Component } from '@angular/core';
import { NavController, AlertController } from 'ionic-angular';
import { SharedDataProvider } from '../../providers/shared-data-provider';
import { ModuleProvider } from '../../providers/module-provider';
import { ConfigurationDataProvider } from '../../providers/configuration-data-provider';
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html',
  animations: [
    trigger('flyInLeft', [
      state('off', style({
        // the view covers the whole screen with a semi tranparent background
        position: 'fixed',
        left: '-100vw'
      })),
      state('on', style({
        position: 'absolute',
        left: '-10vw'
      })),
      transition('off => on', [
        animate('0.3s')
      ]),
      transition('on => off', [
        animate('0.3s')
      ])
    ]),
    trigger('flyInRight', [
      state('off', style({
        // the view covers the whole screen with a semi tranparent background
        position: 'fixed',
        right: '-100vw'
      })),
      state('on', style({
        position: 'absolute',
        right: '0'
      })),
      transition('off => on', [
        animate('0.3s')
      ]),
      transition('on => off', [
        animate('0.3s')
      ])
    ]),
    trigger('flyInTop', [
      state('off', style({
        position: 'fixed',
        top: '-100vw'
      })),
      state('on', style({
        position: 'absolute',
        top: '0'
      })),
      transition('off => on', [
        animate('0.3s')
      ]),
      transition('on => off', [
        animate('0.3s')
      ])
    ]),
    trigger('flyInBottom', [
      state('off', style({
        position: 'fixed',
        bottom: '-100vw'
      })),
      state('on', style({
        position: 'absolute',
        bottom: '0'
      })),
      transition('off => on', [
        animate('0.3s')
      ]),
      transition('on => off', [
        animate('0.3s')
      ])
    ])
  ]
})
export class HomePage {

  private state: string = 'off';

  private isReceipt: boolean = false;
  private isOrder: boolean = false;
  private isTasks: boolean = false;
  private isInventory: boolean = false;

  constructor(public navCtrl: NavController, public shared: SharedDataProvider,
    private moduleProvider: ModuleProvider, private config: ConfigurationDataProvider,
    public alertCtrl: AlertController) {

  }

  ionViewWillEnter() {
    this.isInventory = false;
    this.isOrder = false;
    this.isReceipt = false;
    this.isTasks = false;


    this.moduleProvider.getEnabledModules().subscribe(
      modList => {
        for (var mod of modList) {
          if (mod.id == this.config.modIdTasks)
            this.isTasks = true;
          if (mod.id == this.config.modIdReceipt)
            this.isReceipt = true;
          if (mod.id == this.config.modIdOrder)
            this.isOrder = true;
          if (mod.id == this.config.modIdInventory)
            this.isInventory = true;
        }
      }
    );
  }

  ionViewDidEnter() {
    //this.navCtrl.remove(this.navCtrl.getActive().index - 1);
    this.state = 'on';
  }

  public goToReceipt() {
    console.log('goToReceipt!');
    if (!this.isReceipt) {
      this.showInactiveAlert();
      return;
    }

    this.navCtrl.push('ReceiptChoose');
  }

  public goToTasks() {
    console.log('goToTasks!');
    if (!this.isTasks) {
      this.showInactiveAlert();
      return;
    }
    this.navCtrl.push('TaskSearchPage');
  }

  public goToOrder() {
    console.log('goToOrder!');
    if (!this.isOrder) {
      this.showInactiveAlert();
      return;
    }
  }

  public goToInventory() {
    console.log('goToInventory!');
    if (!this.isInventory) {
      this.showInactiveAlert();
    }
    this.navCtrl.push('InventoryScanLocationOrBinPage');
  }

  private showInactiveAlert() {
    let alert = this.alertCtrl.create({
      title: 'Inaktiv!',
      subTitle: 'Die funktion wurde deaktivert!',
      buttons: ['OK']
    });
    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts